import qs from 'query-string';
import moment from 'moment';
import {Component, Fragment} from 'react';
import injectSheet from 'react-jss';
import {connect} from 'react-redux';

import AuthDateInput from '-/components/fields/AuthDateInput';
import {saveContactByReq, getSegmentById} from '-/api/api';
import Button from '-/components/general/Button';
import Countdown from '-/components/general/Countdown';
import Form from '-/components/fields/Form';
import {Control, ControlGroup} from '-/components/fields/Control';
import {formatCreditorName, renderFieldErrors} from '-/util/util';
import NavigationService from '-/services/NavigationService';
import {get} from '-/util/lodash';

const {segmentId, src, ...theRest} = qs.parse(location.search);
const prefix = '/?offerId=';

const styles = () => ({
    segment: {
        '& p, ul': {
            marginBottom: 10,
            marginTop: 10
        },
        '& ul': {
            listStyleType: 'disc',
            listStylePosition: 'outside',
            marginLeft: 40
        },
        '& li': {
            marginTop: 10
        },
        '& h1': {
            maxWidth: 450,
            margin: '20px auto'
        },
        '& h3': {
            marginTop: 20,
            textAlign: 'center'
        },
        '& .extra-margin': {
            margin: '20px 0'
        },
        '& .desktop': {
            display: 'block'
        },
        '& .mobile': {
            display: 'none'
        },
        '@media all and (max-width: 720px)': {
            '& h1': {
                fontSize: 18,
                fontWeight: 'bold'
            },
            '& h3': {
                marginTop: 0
            },
            '& ul': {
                marginLeft: 15
            },
            '& .desktop': {
                display: 'none'
            },
            '& .mobile': {
                display: 'block'
            }
        }
    }
});

class Segment extends Component {
    constructor(props) {
        super(props);
        this.fieldRefs = {};

        this.state = {
            errors: [],
            offerNotFound: false,
            dob: '',
            segmentInfo: {}
        };
    }

    componentDidMount = async() => {
        const segmentInfo = await getSegmentById(segmentId);
        this.setState({
            segmentInfo
        });
    };

    getErrorMessages = (dob) => {
        const errors = [];
        const momentDate = moment(dob, 'MM/DD/YYYY', true);

        if (!momentDate.isValid()) {
            errors.push('Please enter a date of birth with the following format: MM/DD/YYYY');
        } else if (moment(momentDate).isSameOrAfter(moment(''))) {
            errors.push('Date of birth specified is in the future. Please enter accurate date of birth.');
        }

        return errors;
    };

    handleFormSubmit = async e => {
        e.preventDefault();
        const dateObj = get(this, 'fieldRefs.input.rawValue', {});
        const {day, month, year} = dateObj;
        const dob = `${month}/${day}/${year}`;
        const errors = this.getErrorMessages(dob);

        if (errors.length) {
            this.setState({
                errors
            });
        } else {
            const data = {
                dob,
                extra: {
                    ...theRest
                },
                segmentId,
                src
            };
            const offer = await saveContactByReq(data);
            const {encodedOffer} = offer;

            if (encodedOffer) {
                NavigationService.next('reveal', offer);
            } else {
                this.setState({
                    offerNotFound: true,
                    dob
                });
            }
        }
    };

    render() {
        const {dob, errors, offerNotFound, segmentInfo = {}} = this.state;
        const {goodUntil = moment().endOf('month')} = segmentInfo;
        const {classes = {}, creditorName} = this.props;
        const formattedCreditorName = formatCreditorName(creditorName);

        return (
            <div className={classes.segment}>
                <Form onSubmit={this.handleFormSubmit}>
                    {offerNotFound ? (
                        <p>
                            We could not find your offer. Please double-check that you
                            entered the correct DOB. You entered {moment(dob).format('MM/DD/YYYY')}.
                            Otherwise, you can click <a href={`${prefix}new`}>here</a> to
                            create your own offer.
                        </p>
                    ) : (
                        <div>
                            <h1 className="desktop">Tell us your birthday to REVEAL your savings!</h1>
                            <h1 className="mobile">Enter birthday, reveal savings!</h1>
                            <p>
                                Let {formattedCreditorName}...
                            </p>
                            <ul>
                                <li><b>Lower</b> the rate<sup>*</sup> on your current car loan</li>
                                <li>Estimate your <b>interest savings<sup>*</sup></b></li>
                                <li>Reveal your <b>gift card<sup>*</sup></b> amount ($50-$500)</li>
                            </ul>
                            <p className="extra-margin">
                                Be eligible to defer your next car payment for <b>90 days<sup>*</sup></b> by
                                entering your birthdate below.
                            </p>
                        </div>
                    )}
                    <ControlGroup labelWidth={200}>
                        <Control>
                            <AuthDateInput innerRef={ref => this.fieldRefs.input = ref} />
                        </Control>
                    </ControlGroup>
                    {errors && renderFieldErrors(errors)}
                    <Button
                        type="submit"
                        title="Show My Savings"
                        btnStyle="main">
                        Show My Savings
                    </Button>
                </Form>
                {goodUntil && (
                    <Fragment>
                        <h3>Birthday Offer Expires:</h3>
                        <Countdown date={goodUntil} />
                    </Fragment>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {name: creditorName} = state.creditor;
    return {
        creditorName
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(Segment));